export type Address = {
  address: string;
  city: string;
  zipCode: string;
  state: string;
  country: string;
};
export type AddressFieldName = keyof Address;

export function convertAddressToString(address: Address): string {
  const fieldNames: AddressFieldName[] = Object.keys(address) as AddressFieldName[];
  const separator: string = ', ';

  return fieldNames
    .filter((fieldName: AddressFieldName): boolean => !!address[fieldName])
    .map((fieldName: AddressFieldName): string => address[fieldName])
    .join(separator) || '';
}
